/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema, string } from '../schema';
import { Amount, amountSchema } from './amount';

export interface StatementAmount {
  creditDebitIndicator: string;
  type: string;
  amount: Amount;
}

export const statementAmountSchema: Schema<StatementAmount> = object({
  creditDebitIndicator: ['CreditDebitIndicator', string()],
  type: ['Type', string()],
  amount: ['Amount', lazy(() => amountSchema)],
});
